import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ProjectsService } from 'app/core/services/project/projects.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'app-delete-phase-popup',
  templateUrl: './delete-phase-popup.component.html',
  styleUrls: ['./delete-phase-popup.component.scss']
})
export class DeletePhasePopupComponent implements OnInit {
  modelTitle: string = '';
  selectedOption: string = '1'; // Correct type to string
  jobDetails = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DeletePhasePopupComponent>,
              private formBuilder: FormBuilder,
              private dataCollectorService: DataCollectorService,
              private projectService: ProjectsService,
              private toast: HotToastService,
              public utilityService: UtilityService) { }

  ngOnInit(): void {
    this.selectedOption = '1';
    this.jobDetails = this.data.jobDetails;
  }

  proceedDelete(): void {
    this.dialogRef.close(this.selectedOption);
  }
}
